
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getPipelinesTranslationsDiff",
      resolverType: "query",
      routePath: "/getPipelinesTranslationsDiff",
      httpMethod: "POST",
    });
  